let module = angular.module('app.resources');

module.factory('Products', ($rootScope, Sites, OTT, toaster) => {
  'ngInject';
  const Products = [
    {
      label: 'Streaming',
      icon: 'fa-kit fa-app-live-streaming',
      isAllowed: true,
      handler: () => {
        window.location.href = window.VUE_DASHBOARD_ROOT;
      },
    },
    {
      label: 'RemoteMix',
      icon: 'fa-kit fa-remotemix-secondary',
      isAllowed: !$rootScope.reseller.id,
      handler: () => {
        window.location.href = `${window.VUE_DASHBOARD_ROOT}/remote-mix`;
      },
    },
    {
      label: 'Sites',
      icon: 'fa-kit fa-app-sites',
      isAllowed: true,
      handler: () => {
        if (!$rootScope.account.feature_flags.sites) {
          window.location.href = `${window.VUE_DASHBOARD_ROOT}/sites`;
          return;
        }
        Sites.getSites(
          {},
          (response) => {
            if (response.length === 0) {
              window.location.href = `${$rootScope.vueDashboardRoot}/sites`;
            } else {
              Sites.getSSOLink(
                {},
                (data) => {
                  if (data.url) {
                    window.location.href = data.url;
                  }
                },
                (err) => error(err)
              );
            }
          },
          (err) => error(err)
        );

        function error(err) {
          toaster.pop('error', 'Something went wrong. Unable to connect to Sites.');
          console.log('Something went wrong connecting to Sites', err);
        }
      },
    },
    {
      label: 'OTT',
      icon: 'fa-kit fa-ott-icon',
      isAllowed: true,
      handler: function () {
        try {
          // Route all users to Vue dashboard OTT landing page
          // Let the Vue dashboard handle routing logic based on user permissions
          window.location.href = `${window.VUE_DASHBOARD_ROOT}/ott-apps`;
        } catch (error) {
          console.error('Error in OTT handler:', error);
          toaster.pop('error', 'Something went wrong. Unable to connect to BoxCast OTT.');
        }
      },
    },
  ].filter((item) => item.isAllowed);

  return Products;
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/products.js